import 'react-multi-carousel/lib/styles.css';

import React from 'react';
import Carousel from 'react-multi-carousel';

import variables from '../../../themes/variables.module.scss';
import { BasicCardVariants } from '../../../utils/_enums/basic-card-variants.enum';
import styles from './carousel.module.scss';

export interface CarouselComponentProps {
    items: any[];
    type: BasicCardVariants;
    inverted?: boolean;
    className?: string
}

const CarouselComponent = (props: CarouselComponentProps): JSX.Element => {
    return (
        <div
            className={`${props.className || ''} ${styles['carousel-wrapper']} ${styles[props.type]}`}
            data-testid="carousel-component"
        >
            <Carousel
                additionalTransfrom={0}
                arrows={props.items && props.items.length > 1}
                autoPlaySpeed={3000}
                autoPlay={props.items && props.items.length > 1}
                centerMode={false}
                containerClass={`${styles['carousel-container']}`}
                dotListClass={`${styles['carousel-dots']} ${
                    styles[`${props.inverted && 'inverted'}`]
                }`}
                draggable={props.items && props.items.length > 1}
                focusOnSelect={false}
                infinite
                itemClass={`${styles['carousel-item']}`}
                keyBoardControl
                minimumTouchDrag={80}
                renderButtonGroupOutside={false}
                renderDotsOutside={true}
                responsive={{
                    desktop: {
                        breakpoint: {
                            max: 8192,
                            min: Number(variables.desktopSmall.slice(0, -2))
                        },
                        items: 1
                    },
                    mobile: {
                        breakpoint: {
                            max: Number(variables.mobile.slice(0, -2)),
                            min: 0
                        },
                        items: 1
                    },
                    tablet: {
                        breakpoint: {
                            max: Number(variables.desktopSmall.slice(0, -2)),
                            min: Number(variables.mobile.slice(0, -2))
                        },
                        items: 1
                    }
                }}
                sliderClass={`${styles['carousel-sliderClass']}`}
                showDots={props.items && props.items.length > 1}
                slidesToSlide={1}
                swipeable={props.items && props.items.length > 1}
                partialVisible
            >
                {props.items.map((item, index) => (
                    <div key={index} className={styles['item']}>
                        {item}
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

export default CarouselComponent;
